import { useExternalRoleQuery } from './useExternalRoleQuery';
import { useExternalRolesQuery } from './useExternalRolesQuery';
import { useExternalRoleUserCountsQuery } from './useExternalRoleUserCountsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface ArchiveExternalRolesMutationParams {
  roleIds: string[];
}

export const useExternalRolesArchiveMutation = createMutationHook(
  'settings.customerPortal.archiveRoles',
  (params: ArchiveExternalRolesMutationParams) => ({
    coreRolesArchive: {
      __args: {
        input: {
          roleIds: params.roleIds,
        },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
  {
    invalidateQueries: [
      useExternalRolesQuery,
      useExternalRoleUserCountsQuery,
      useExternalRoleQuery,
    ],
  },
);
